import React, { FC } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import styled from 'styled-components';
import { Panel, Content } from '../styled/Panel';
import Heading from '../styled/Heading';
import Footer from './Footer';
import Header from './header/Header';
import LayoutContent from './LayoutContent';

interface IProps {
  title: string;
  isLoading?: boolean;
  error?: unknown;
  children?: React.ReactNode;
}

const MainLayout: FC<IProps> = ({ title, isLoading = false, error, children }: IProps) => {
  return (
    <Wrapper>
      <Header />
      <InnerWrapper>
        <Panel className="u-inner">
          <Heading>
            <Container fluid>
              <Row>
                <Col>
                  <h2 className="h4 mb-0 text-center text-md-left">{title}</h2>
                </Col>
              </Row>
            </Container>
          </Heading>
          <Content>
            <Container fluid>
              <Row>
                <Col>
                  <LayoutContent
                    isLoading={isLoading}
                    error={error}
                  >
                    {children}
                  </LayoutContent>
                </Col>
              </Row>
            </Container>
          </Content>
        </Panel>
      </InnerWrapper>
      <Footer />
    </Wrapper>
  );
};

export default MainLayout;

const Wrapper = styled.div`
  padding-top: 72px;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;

const InnerWrapper = styled.div`
  padding: 2rem;
  flex: 1;

  @media ${props => props.theme.breakpoints.lg} {
    padding: 1rem 1rem;
  }
`;
